<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="actualizado()">
        <div class="card">
            <div v-if="localEntrada.butaca === null && !localEntrada.numero === null" class="card-header bg-secondary">
                {{ localEntrada.asiento.zona_nombre ?? localEntrada.zona_nombre }} <br/>
                <span v-if="localEntrada.asiento.fila && localEntrada.asiento.asiento">Fila: {{ localEntrada.asiento.fila }} / Butaca: {{ localEntrada.asiento.asiento }}</span>
                <span v-else>Sin numerar</span>
            </div>
            <div v-else-if="localEntrada.butaca !== null" class="card-header bg-secondary">
                <span>Sector: {{ localEntrada.nombre_sector ?? localEntrada.sector_name }}</span> <br/>
                <span>Fila: {{ localEntrada.fila }} / Butaca: {{ localEntrada.butaca }}</span>
            </div>
            <div v-else-if="localEntrada.numero !== null" class="card-header bg-secondary">
                <span>Plaza: {{ localEntrada.numero }}</span>
            </div>
            <div class="card-body">
                <template v-if="solicitar_datos">
                    <FormInput id="nombre" label="Nombre" name="Nombre" v-model="localEntrada.nombre" @change="actualizado" />
                    <FormInput id="apellidos" label="Apellidos" name="Apellidos" v-model="localEntrada.apellidos" @change="actualizado" />
                    <div class="form-group">
                        <DocumentoTipo
                            v-model="localEntrada.tipoDocumento"
                            :index="index"
                        />
                    </div>

                    <div class="form-group">
                        <DocumentoValor
                            v-model="localEntrada.dni"
                            :type="localEntrada.tipoDocumento"
                            :index="index"
                            @input="actualizado"
                            :required="false"
                        />
                    </div>
                </template>

                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                        <select class="form-control rounded-pill" id="select-precio" v-model="localEntrada.precio" v-on:change="actualizado" :disabled="disableInput">
                            <template v-for="(precio, index) in localEntrada.precios">
                                <option v-if="!localEntrada.butaca && !localEntrada.numero" :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                                <option v-else :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                            </template>
                        </select>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group" v-if="teatro.solicitar_genero_taquilla">
                    <label for="genero">Género</label>
                    <select class="form-control rounded-pill" id="select-genero" v-model="localEntrada.genero_id" v-on:change="actualizado" :disabled="disableInput">
                        <template v-for="genero in generos">
                            <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                        </template>
                    </select>
                </div>
                <div class="form-group " v-if="permisos['venta.descuento']">
                    <label for="descuento">Descuento</label>
                    <select v-model="localEntrada.descuento" class="form-control rounded-pill" id="select-descuento" v-on:change="actualizado" :disabled="disableInput">
                        <option value="0">Sin descuento</option>
                        <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                            <option :key="index" :value="descuento">{{ descuento }}%</option>
                        </template>
                    </select>
                </div>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, fieldIndex) in fields" :key="fieldIndex" class="form-group">
                        <FieldComponent
                            :field="field"
                            :entradaIndex="index"
                            :fieldIndex="fieldIndex"
                            v-model="localEntrada.properties[field.name]"
                            v-on:input="actualizado"
                        />
                    </div>
                </template>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import FieldComponent from '@/components/common/FieldComponent';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';

    export default {
        props: {
            entrada: {
                type: Object,
                required: true
            },
            generos: {
                type: Array,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            solicitar_datos: {
                type: [Number, Boolean],
                required: false,
                default: false
            },
            fields: {
                type: Array,
                required: false,
                default: () => []
            },
            abonado: {
                type: Object,
                required: false
            },
            disableInput: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localEntrada: {...this.entrada, tipoDocumento: 'DNI' }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            if (this.fields && this.fields.length > 0) {
                if (!this.localEntrada.properties) {
                    this.localEntrada.properties = {};
                    this.fields.forEach(field => {
                        this.localEntradatrada.properties[field.name] = null;
                    });
                }
            }

            if(this.localEntrada.precios.length === 1){
                this.localEntrada.precio = this.localEntrada.precios[0]
            }

            if(this.index === 0 && this.abonado && this.abonado.info_abonado && this.abonado.info_abonado.dni){
                this.localEntrada.dni = this.abonado.info_abonado.dni;
                if(this.abonado.info_abonado.nombre) {
                    this.localEntrada.nombre = this.abonado.info_abonado.nombre;
                }
                if(this.abonado.info_abonado.apellidos) {
                    this.localEntrada.apellidos = this.abonado.info_abonado.apellidos;
                }
            }

            this.actualizado();
        },
        methods: {
            actualizado(field, checkboxError) {
                if (this.entrada.telefono && !this.localEntrada.telefono) {
                    this.localEntrada.telefono = this.entrada.telefono;
                }else if(!this.entrada.telefono && !this.localEntrada.telefono) {
                    delete this.localEntrada.telefono;
                }
                this.$emit('actualizado', checkboxError, this.localEntrada);
            },
            getPrecio(precio) {
                let price = parseFloat(precio.precio);

                if(precio.price_management_interno_taquilla || precio.gd_interno) {
                    return price;
                }

                return price + parseFloat(precio.price_management_taquilla);
            }
        },
        components: {
            FieldComponent, DocumentoTipo, DocumentoValor
        }
    }
</script>
